import { useQuery } from '@tanstack/react-query'
import { webLogService, type WebLogsParams } from '@/services/webLog.service'

export const useWebLogs = (params?: WebLogsParams) => {
  return useQuery({
    queryKey: ['web-logs', params],
    queryFn: () => webLogService.list(params),
    staleTime: 30000
  })
}
